export default "__VITE_ASSET__20e4976e__"